<template>
  <div v-if="wartungsfensterStore.istAktiv" class="fixed top-1 left-1/2 -translate-x-1/2 z-[60]">
    <div
      class="relative backdrop-blur-sm bg-gradient-to-r from-amber-500/90 via-yellow-500/90 to-amber-500/90 dark:from-amber-600/90 dark:via-yellow-600/90 dark:to-amber-600/90 rounded-full shadow-lg border border-yellow-400/50 dark:border-yellow-500/50"
    >
      <div class="px-6 py-2 flex items-center gap-3">
        <ExclamationTriangleIcon class="h-6 w-6 text-amber-900 dark:text-amber-100" />
        <div class="font-medium text-sm text-slate-900 dark:text-white whitespace-nowrap">
          {{ t('warning.wartungsfenster.sessionWillBeTerminatedEndWork') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWartungsfensterStore } from '@/stores/wartungsfensterStore';
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const wartungsfensterStore = useWartungsfensterStore();
</script>
